import _extends from "@babel/runtime/helpers/extends";
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Small } from '../../../Typography';
import { SLIDER_TICK_LABEL_TOP_POSITION } from '../constants';
import { getPercent } from '../../../helpers/common';
import { useDeviceType, useMediaBreakpoints, useTap } from '../../../hooks';
import { sizes } from '../../../breakpoints';
import { top } from '../../../style/top';
const StyledTickText = styled(Small)`
  display: inline-block;
  position: absolute;
  ${top(SLIDER_TICK_LABEL_TOP_POSITION)};
  text-align: center;
  transform: translateX(-50%);
  width: calc(${({
  $count
}) => getPercent(100 / $count)} - 8px);
  left: ${({
  $percent
}) => getPercent($percent)};
  cursor: ${({
  $clickable
}) => $clickable ? 'pointer' : 'default'};

  ${({
  $first,
  $align
}) => $first && $align && `
    text-align: left;
    transform: translateX(0);
  `}
  ${({
  $last,
  $align
}) => $last && $align && `
    text-align: right;
    transform: translateX(-100%);
  `}
`;
export const SliderTickLabel = ({
  align = false,
  disabled = false,
  label,
  tick,
  count,
  format,
  measureHeight,
  onClick,
  ...props
}) => {
  const {
    value,
    percent
  } = tick;
  const {
    hasTouchScreen
  } = useDeviceType();
  const screen = useMediaBreakpoints(sizes);
  const setValue = useCallback(() => onClick?.(value), [onClick, value]);
  const {
    setRef: setTapRef
  } = useTap(setValue, null, hasTouchScreen, disabled);
  const setRef = useCallback(ref => {
    setTapRef(ref);
    if (ref) {
      measureHeight?.(ref.offsetHeight);
    }
  }, [setTapRef, measureHeight, screen]);
  return /*#__PURE__*/React.createElement(StyledTickText, _extends({
    ref: setRef,
    hyphens: true,
    $align: align,
    $percent: percent,
    $count: count,
    $clickable: onClick,
    $first: percent === 0,
    $last: percent === 100
  }, props), label ?? (format ? format(value) : null));
};